import { useTranslation } from 'react-i18next';
import { CollapseProperties } from '../data/LockerDataTypes';
import CollapseComponent from './CollapseComponent';
import LockerList from './LockerList';

const LockerListContainer = () => {
    const { t } = useTranslation();
    const properties: CollapseProperties = {
        componentId: "collapse-list",
        textShowButton: t('hideEasyboxList'),
        textHideButton: t('showEasyboxList')
    };

    return (
        <>
        <div className="locker-plugin-locker-list-container">
            <CollapseComponent properties={properties}><LockerList/></CollapseComponent>
        </div>
        </>
    )
}

export default LockerListContainer;
